import LabelingOverview from '../LabelingOverview.vue';
import LabelingConfig from '../LabelingConfig.vue';
import MonitorOverview from '@/views/home/shared/MonitorOverview.vue';

export default {
  path: '/fx-rate',
  name: 'FxRate',
  redirect: { name: 'FxRateConfig' },
  component: LabelingOverview,
  meta: { menuItemName: 'FxRate' },
  children: [
    {
      path: 'config',
      name: 'FxRateConfig',
      component: LabelingConfig
    },
    {
      path: 'monitor',
      name: 'FxRateMonitor',
      component: MonitorOverview
    }
  ]
};
